import Drawable from '../entities/Drawable.js';
import Sprite from './Sprite.js';
import { imageStore } from '../images.js';

export default class PokemonIcon extends Drawable {
    constructor({ pokemon, position = { x: 0, y: 0 }, selected = false }) {
        super();
        this.pokemon = pokemon;
        this.position = position;
        this.selected = selected;
        this.sprites = {};
        this.sprites.pokemonIcon = new Sprite({
            position: { x: 0, y: 0 },
            image: imageStore.get('img/spritesheets/pokemon_mini_master_spritesheet_20_20.png'),
            isFromSpriteSheet: true,
            spriteSheetCols: 20,
            spriteSheetRows: 20,
            spriteIndex: 0,
            visible: false,
        });
    }

    draw() {
        if (this.pokemon === null) {
            return;
        }
        if (this.sprites.pokemonIcon === null || this.sprites.pokemonIcon === undefined) {
            return;
        }
        this.sprites.pokemonIcon.visible = true;
        this.sprites.pokemonIcon.position = {
            x: this.position.x + 16 * (1 - this.sprites.pokemonIcon.scale),
            y: this.position.y + 16 * (1 - this.sprites.pokemonIcon.scale),
        };

        this.sprites.pokemonIcon.spriteIndex = this.pokemon.id - 1;
        this.sprites.pokemonIcon.draw();
    }

    shrink() {
        if (this.sprites.pokemonIcon.scale <= 0) {
            return true;
        }
        this.sprites.pokemonIcon.scale -= 0.025;
    }
}
